import {Injectable} from '@angular/core';
import {HttpClientService} from '../../services/http-client.service';
import {Utils} from '../../services/utils';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class NewSimulationService {

    public sections = [
        {
            id: 'product-information',
            active: false,
            completed: false,
            data: []
        },
        {
            id: 'mea-selection',
            active: false,
            completed: false,
            data: []
        },
        {
            id: 'tender-selection',
            active: false,
            completed: false,
            data: []
        },
        {
            id: 'simulation-input',
            active: false,
            completed: false,
            data: []
        }, {
            id: 'simulation-result',
            active: false,
            completed: false,
            data: []
        }
    ];

    constructor(private http: HttpClientService) {
    }

    public fetchResults(discountType: string): Observable<any> {
        let sourceData = this.sections[2].data;

        let data = Utils.convertArrayToObject(sourceData);

        if (discountType === 'PVA-V') {

            data['S_THRESHOLDS'] = [];
            data['PRCCONFIDDISCCYC'] = [];

            for (const periodData of sourceData) {
                let valueLimits = '';
                let discounts = '';

                const pvavs = periodData['PVA_V'];

                valueLimits = "" + pvavs[0]['valueLimit'];
                discounts = "" + pvavs[0]['discount'];

                if (pvavs.length > 1) {
                    for (let i = 1; i < pvavs.length; i++) {
                        if (pvavs[i]['valueLimit']) {
                            valueLimits += '_' + pvavs[i]['valueLimit'];
                        }
                        if (pvavs[i]['discount']) {
                            discounts += '_' + pvavs[i]['discount'];
                        }
                    }
                }

                data['S_THRESHOLDS'].push(valueLimits);
                data['PRCCONFIDDISCCYC'].push(discounts);
            }

            sourceData['S_THRESHOLDS'] = data['S_THRESHOLDS'];
            sourceData['PRCCONFIDDISCCYC'] = data['PRCCONFIDDISCCYC'];

        }

        if (discountType === 'PVA-S') {
            data['S_THRESHOLDS'] = [];
            data['PRCCONFIDDISCCYC'] = [];

            for (const periodData of sourceData) {
                let valueLimits = '';
                let discounts = '';

                const pvavs = periodData['PVA_S'];

                valueLimits = "" + pvavs[0]['priceLimit'];
                discounts = "" + pvavs[0]['discount'];

                if (pvavs.length > 1) {
                    for (let i = 1; i < pvavs.length; i++) {
                        if (pvavs[i]['priceLimit']) {
                            valueLimits += '_' + pvavs[i]['priceLimit'];
                        }
                        if (pvavs[i]['discount']) {
                            discounts += '_' + pvavs[i]['discount'];
                        }
                    }
                }

                data['S_THRESHOLDS'].push(valueLimits);
                data['PRCCONFIDDISCCYC'].push(discounts);
            }

            sourceData['S_THRESHOLDS'] = data['S_THRESHOLDS'];
            sourceData['PRCCONFIDDISCCYC'] = data['PRCCONFIDDISCCYC'];
        }

        let url = '';

        switch (discountType) {
            case 'HD': {
                url = 'hiddendiscount';
                break;
            }

            case 'EC': {
                url = 'expenditurecap';
                break;
            }

            case 'PVA': {
                url = 'pvagreement';
                break;
            }

            case 'PVA-V': {
                url = 'pvagreement';
                break;
            }

            case 'PVA-S': {
                url = 'pvagreement_sales';
                break;
            }

            case 'FCPP' : {
                url = 'fixedcost';
                break;
            }

            case 'DTI': {
                url = 'discountedtreatment';
                break;
            }

            case 'UC': {
                url = 'utilisationcap';
                break;
            }
        }

        if (data) {
            return this.http.post(url, data);
        }
    }

    public fetchResultForData(data: any, discountType: string): Observable<any> {

        // let preparedData = Utils.convertArrayToObject(data);
        let url = '';

        switch (discountType) {
            case 'HD': {
                url = 'hiddendiscount';
                break;
            }

            case 'EC': {
                url = 'expenditurecap';
                break;
            }

            case 'PVA-V': {
                url = 'pvagreement';
                break;
            }

            case 'PVA-S': {
                url = 'pvagreement_sales';
                break;
            }

            case 'FCPP' : {
                url = 'fixedcost';
                break;
            }

            case 'DTI': {
                url = 'discountedtreatment';
                break;
            }

            case 'UC': {
                url = 'utilisationcap';
                break;
            }
        }

        if (data) {

            if (data['FCPP']) {
                data['FCPPC'] = data['FCPP'];
            }

            return this.http.post(url, data);
        }
    }

    public fetchRegions(): Observable<any> {
        return this.http.post('getregions', null);
    }

    public fetchCountriesByRegion(region): Observable<any> {
        return this.http.post('getcountriesfromregion', {Country_Region_1: region});
    }

    public fetchCurrencyByCountry(country): Observable<any> {
        return this.http.post('getcurrencyforcountry', {Country_name: country});
    }

    public fetchMedicineDetails(medicine): Observable<any> {
        const data = {brand_0: medicine};

        return this.http.post('getmedicinedetails', data);
    }

    public saveSimulation(data: any): Observable<any> {

        const preparedData = this.prepareData(data);

        return this.http.post('savescenario', preparedData);
    }

    public editSimulation(data: any): Observable<any> {


        for (const dataKey in data['data']) {
            data[dataKey] = data['data'][dataKey];
        }

        data['simulation_date'] = (new Date(data['simulation_date']).getTime() / 1000);


        let startDate = data['startEndDate']['beginDate'];
        let endDate = data['startEndDate']['endDate'];

        data['Expected_start_date'] = startDate.year + '-' + (startDate.month < 10 ? '0' + startDate.month : startDate.month) + '-' + (startDate.day < 10 ? '0' + startDate.day : startDate.day);
        data['Expected_end_date'] = endDate.year + '-' + (endDate.month < 10 ? '0' + endDate.month : endDate.month) + '-' + (endDate.day < 10 ? '0' + endDate.day : endDate.day);

        console.log(data);
        return this.http.post('editscenario', data);
    }

    public deleteSimulation(data: any): Observable<any> {

        const body = {
            Simulation_id : data['Simulation_id']
        };

        return this.http.post('deletescenario', body);
    }

    public prepareData(rawData: any): any {
        const data = {};

        const section1 = rawData[0];
        const section2 = rawData[1];
        const section3 = rawData[2];
        const section4 = rawData[3];


        data['Simulation_Name'] = section1['data']['simulationTitle'];
        data['Simulation_type'] = section2['data'][0]['agreementType'];
        data['Scenario_description'] = section3['data']['description'];
        data['simulation_date'] = Number.parseInt(new Date().getTime() / 1000 + '');

        let s1Data = section1['data'][0];
        if (s1Data['brandName'] === 'other') {
            data['Brand_Name'] = s1Data['otherBrand'];
        } else {
            data['Brand_Name'] = s1Data['brandName'];
        }


        data['Active_ingredient'] = s1Data['activeIngredients'];
        data['Strength'] = s1Data['strengthValue'];
        data['Strength_unit'] = s1Data['strengthUnit'];
        data['Pack_size'] = s1Data['packSize'];
        data['ATC_code'] = s1Data['ATCCode'];
        data['Form'] = s1Data['form'];
        data['Currency'] = section2['data'][0]['currency'];

        data['Country_name'] = section2.data[0]['country'];

        let startDate = section2.data[0]['startEndDate']['beginDate'];
        let endDate = section2.data[0]['startEndDate']['endDate'];

        data['Expected_start_date'] = startDate.year + '-' + (startDate.month < 10 ? '0' + startDate.month : startDate.month) + '-' + (startDate.day < 10 ? '0' + startDate.day : startDate.day);
        data['Expected_end_date'] = endDate.year + '-' + (endDate.month < 10 ? '0' + endDate.month : endDate.month) + '-' + (endDate.day < 10 ? '0' + endDate.day : endDate.day);

        data['Num_of_cycles'] = Number.parseInt(section2.data[0]['numberOfMEAPeriods']);
        if (section2.data[0]['contractingPartner']) {
            data['Contracting_partner'] = section2.data[0]['contractingPartner'];
        } else {
            data['Contracting_partner'] = ' ';
        }

        let s3Keys = Object.keys(section3.data[0]);

        for (let key of s3Keys) {
            data[key] = [];
        }

        for (let s3Data of section3.data) {
            for (let key of s3Keys) {

                if (s3Data[key].length > 0) {
                    data[key].push(s3Data[key]);
                }
            }
        }

        let s4Keys = Object.keys(section4.data);
        for (let key of s4Keys) {
            data[key] = section4.data[key];
        }

        if (section3.data['PRCCONFIDDISCCYC']) {
            data['PRCCONFIDDISCCYC'] = section3.data['PRCCONFIDDISCCYC'];
        }

        if (section3.data['S_THRESHOLDS']) {
            data['S_THRESHOLDS'] = section3.data['S_THRESHOLDS'];
        }

        return data;
    }

}

export enum MEAPeriodTypes {
    HD,
    EC,
    PVA,
    FCPP,
    DTI,
    UC
}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/new-simulation.service.ts